import axios, { AxiosInstance, AxiosRequestConfig, AxiosError } from "axios";
import { usePortalAuthStore } from "../store/portalAuth.store";

const PORTAL_API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "";

export const portalApiClient: AxiosInstance = axios.create({
  baseURL: `${PORTAL_API_BASE_URL}/portal`,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 30000,
});

portalApiClient.interceptors.request.use(
  (config) => {
    const token = usePortalAuthStore.getState().sessionToken;
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

portalApiClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError<{ message?: string; code?: string; error?: string }>) => {
    const requestUrl = error.config?.url || "";
    const isAuthEndpoint = requestUrl.includes("/auth/");
    if (error.response?.status === 401 && !isAuthEndpoint) {
      usePortalAuthStore.getState().logout();
      window.location.href = "/portal/login";
    }
    const apiMessage =
      error.response?.data?.message || error.response?.data?.error;
    if (apiMessage) {
      const customError = new Error(apiMessage);
      (customError as any).response = error.response;
      (customError as any).code = error.response?.data?.code;
      return Promise.reject(customError);
    }
    return Promise.reject(error);
  }
);

export const portalApi = {
  get: <T>(url: string, config?: AxiosRequestConfig) =>
    portalApiClient.get<T>(url, config).then((res) => res.data),
  post: <T>(url: string, data?: unknown, config?: AxiosRequestConfig) =>
    portalApiClient.post<T>(url, data, config).then((res) => res.data),
  put: <T>(url: string, data?: unknown, config?: AxiosRequestConfig) =>
    portalApiClient.put<T>(url, data, config).then((res) => res.data),
  delete: <T>(url: string, config?: AxiosRequestConfig) =>
    portalApiClient.delete<T>(url, config).then((res) => res.data),
};

export default portalApiClient;
